import React from 'react';
import { Shield, UserCircle } from 'lucide-react';
import ConsultationForm from '../ConsultationForm';

const BenefitsSection = ({ onFormSubmit }) => (
  <section className="benefits-section">
    <div className="section-container">
      <h2 className="section-headline">Quantified Outcomes You Can Feel Fast</h2>
      <div className="benefits-grid">
        <div className="benefit-card numeric-card">
          <div className="benefit-number">15% to 40%</div>
          <div className="benefit-subtext">Cost Savings</div>
          <h3 className="benefit-title">15% to 40% Cost Savings</h3>
          <p className="benefit-description">
            See how much you can save compared to your current big box PEO with a clear, apples to apples cost review.
          </p>
        </div>
        <div className="benefit-card numeric-card">
          <div className="benefit-number">Same Day</div>
          <div className="benefit-subtext">Response & Resolution</div>
          <h3 className="benefit-title">Same Day Response & Resolution</h3>
          <p className="benefit-description">
            We strive for same day response and resolution instead of waiting through multi day ticket queues.
          </p>
        </div>
        <div className="benefit-card icon-card">
          <Shield size={48} className="benefit-icon" />
          <h3 className="benefit-title">FirstAdvantage Benefits</h3>
          <p className="benefit-description">
            Access FirstAdvantage™ Benefits, including proprietary zero deductible health plan options and custom GAP insurance.
          </p>
        </div>
        <div className="benefit-card icon-card">
          <UserCircle size={48} className="benefit-icon" />
          <h3 className="benefit-title">Direct Rep Access</h3>
          <p className="benefit-description">
            Text or call your named reps directly, so you stop re-explaining your business every time you need help.
          </p>
        </div>
      </div>
      <div className="benefits-form-container">
        <ConsultationForm onSubmit={onFormSubmit} source="main" />
      </div>
    </div>
  </section>
);

export default BenefitsSection;
